import React from 'react'
import { Link } from 'react-router-dom'

export function LegalHeader() {
  return (
    <header className="w-full bg-white border-b border-stone">
      <div className="max-w-5xl mx-auto px-4 h-14 flex items-center">
        <Link to="/" aria-label="Home" className="text-2xl font-bold text-dusk tracking-tight">
          nura
        </Link>
      </div>
    </header>
  )
}

